import reducer from './reducers';

export { default as regionsSelectors } from './selectors';
export { default as regionsOperations } from './operations';
export { default as regionsTypes } from './types';
export { default as normalizeData } from './schema';

export default reducer;
